import * as React from 'react';
import { connect } from 'react-redux';
import CheckersQueue from '../CheckersQueue';
import { UserInfo } from '../../../Login/common/defaults';
import { showLoadingWithMessage } from '../../../Application/redux-objects/actions';
import { assignWorkflowItem } from '../../redux-objects/actions';
import { IWorkflowStepDetails } from '../../common/types';

interface ICheckersQueueControllerOwnProps {
  history: any;
  dataEntry: any;
  match: any;
  queueToLoad: eCheckersQueue;
}

interface ICheckersQueueControllerPropsFromState {
  webServiceURL: string;
  currentUser: UserInfo;
  workflowStepsLoading: boolean;
  workflowSteps: IWorkflowStepDetails[];
}

interface ICheckersQueueControllerActions {
  showLoadingWithMessage: (show: boolean, message?: string) => void;
  assignWorkflowItem: (
    url: string,
    stepItemId: number,
    assignToId: number
  ) => Promise<any>;
}

export enum eCheckersQueue {
  CheckersReview,
}

type ICheckersQueueControllerProps = ICheckersQueueControllerOwnProps &
  ICheckersQueueControllerPropsFromState &
  ICheckersQueueControllerActions;

export class QueueController extends React.Component<
  ICheckersQueueControllerProps
> {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    this.props.showLoadingWithMessage(
      this.props.workflowStepsLoading,
      'Loading Queue Information ...'
    );
  }

  render() {
    return (
      <React.Fragment>
        {!this.props.workflowStepsLoading &&
          this.props.workflowSteps.length > 0 && (
            <CheckersQueue
              endPoint={this.props.webServiceURL}
              currentUser={this.props.currentUser}
              history={this.props.history}
              queueToShow={this.props.queueToLoad}
              assignWorkflowItem={this.props.assignWorkflowItem}
              workflowSteps={this.props.workflowSteps}
            />
          )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    webServiceURL: reduxState.Application.backendURL,
    currentUser: reduxState.Application.currentUser,
    workflowStepsLoading: reduxState.WorkflowQueues.WorkFlowStepsLoading,
    workflowSteps: reduxState.WorkflowQueues.WorkFlowSteps,
  };
};

const mapDispatchToProps = {
  showLoadingWithMessage,
  assignWorkflowItem,
};

export default connect<
  ICheckersQueueControllerPropsFromState,
  ICheckersQueueControllerActions
>(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
  QueueController
);
